/**
 * 学期信息模块接口列表
 */

import base from '../base' // 导入接口域名列表
import axios from '../../request/http' // 导入http中创建的axios实例

const dictionaryApi = {
  GetDataList: `${base.qa}/Semester/GetDataList`,
  SaveData: `${base.qa}/Semester/SaveData`,
  DelData: `${base.qa}/Semester/DelData`,
  GetDataItemDetailInfo: `${base.qa}/DataItem/GetDataItemDetailInfo`,
  SaveDataItem: `${base.qa}/DataItem/SaveDataItem`,
  GetDataItemInfo: `${base.qa}/DataItem/GetDataItemInfo`,
  DelDataItem: `${base.qa}/DataItem/DelDataItem`,
  GetDataItemListByCode: `${base.qa}/DataItem/GetDataItemListByCode`,
  GetDataItemDetailTreeListByItemCode: `${base.qa}/DataItem/GetDataItemDetailTreeListByItemCode`
}

const dictionary = {
  GetDataList(params) {
    return axios.get(dictionaryApi.GetDataList, { params })
  },
  SaveData(params) {
    return axios.post(dictionaryApi.SaveData, params)
  },
  DelData(params) {
    return axios.post(dictionaryApi.DelData, params)
  },
  GetDataItemDetailInfo(params) {
    return axios.get(dictionaryApi.GetDataItemDetailInfo, { params: { itemdetailid: params } })
  },
  SaveDataItem(params) {
    return axios.post(dictionaryApi.SaveDataItem, params)
  },
  GetDataItemInfo(params) {
    return axios.get(dictionaryApi.GetDataItemInfo, { params: { itemid: params } })
  },
  GetDataItemListByCode(params) {
    return axios.get(dictionaryApi.GetDataItemListByCode, { params })
  },
  GetDataItemDetailTreeListByItemCode(params) {
    return axios.get(dictionaryApi.GetDataItemDetailTreeListByItemCode, { params: { itemcode: params } })
  },
  DelDataItem(params) {
    return axios.post(dictionaryApi.DelDataItem, params)
  }
}

export default dictionary

